import {alpha, styled} from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";

export const BootstrapInput = styled(InputBase)(({theme}) => ({
    width: '100%',
    'label + & , label.MuiInputLabel-root': {
        marginTop: 0,
        lineHeight: '1rem !important',
    },
    '& textarea': {
        height: '120px',
    },

    '&.erroredInput': {
        '& input': {
            borderColor: `${theme.palette.error.main} !important`,
            borderRadius: 4,
        },
    },

    '& .MuiInputBase-input, & textarea': {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: '#F3F6F9',
        marginTop: 0,
        border: '1px solid',
        width: '100%',
        borderColor: '#E0E3E7',
        fontSize: 16,
        padding: '10px 12px',
        transition: theme.transitions.create([
            'border-color',
            'background-color',
            'box-shadow',
        ]),
        '&:focus': {
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
        ...theme.applyStyles('dark', {
            backgroundColor: '#1A2027',
            borderColor: '#2D3843',
        }),
    },
}));
